import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import { useTranslation } from "react-i18next";
import { Button } from "@components/buttons";
import ReactMarkdown from "react-markdown";

export default observer(function OnboardingNextPopup(props: {
	isOnboardingNextPopupActive: boolean;
}) {
	const { t } = useTranslation();

	const rootStore = useRootAppStore();

	if (!props.isOnboardingNextPopupActive) {
		return null;
	}

	return (
		<div
			className="popup popup--marketing"
			data-at="at-OnboardingNextPopup"
		>
			<div className="popup__card popup--marketing__card">
				<div className="popup__header popup--marketing__header">
					<Button
						type="button"
						onClick={() => {
							rootStore.onboardingWelcomePopupStore.onboardingNextStore.hidePopup();
						}}
						className="btn--round btn--round--sml btn--secondary--inverted popup--marketing__close"
						iconOnly
						iconClassName="u-icon--tny u-icon--close u-color--core--snow"
					/>
				</div>

				<div
					className="popup__body popup--marketing__body"
					onClick={() => {
						rootStore.onboardingWelcomePopupStore.onboardingNextStore.redirectToNextPage();
					}}
				>
					<div className="popup--marketing__title">
						{t("MARKETING.NEXT_POPUP.TITLE")}
					</div>

					<div className="popup--marketing__thumbnail">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 1651 456"
							className="popup--marketing__thumbnail__item popup--marketing__thumbnail__left"
						>
							<g fill-rule="nonzero">
								<path
									fill="none"
									d="M1258.5 112.5V0H1651v112.5h-131V456h-127V112.5h-134.5Zm-206.5 268 50.5 75.5H1254l-132-180-70 104.5Zm0-305L1102.5 0H1254l-132 180-70-104.5Z"
								/>
								<path d="M972.5 175 863 0h109.5l151 227-151 229H863l109.5-177h-178V175h178Z" />
								<path
									fill="none"
									d="M483.5 456V0h367v118.5h-237V172H768v111H613.5v60h237v113h-367ZM0 456V0h132l170 242V0h135.5v456H302L132 214v242H0Z"
								/>
							</g>
						</svg>

						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 1651 456"
							className="popup--marketing__thumbnail__item popup--marketing__thumbnail__right"
						>
							<g fill-rule="nonzero">
								<path d="M1258.5 112.5V0H1651v112.5h-131V456h-127V112.5h-134.5Zm-206.5 268 50.5 75.5H1254l-132-180-70 104.5Zm0-305L1102.5 0H1254l-132 180-70-104.5Z" />
								<path
									fill="none"
									d="M972.5 175 863 0h109.5l151 227-151 229H863l109.5-177h-178V175h178Z"
								/>
								<path d="M483.5 456V0h367v118.5h-237V172H768v111H613.5v60h237v113h-367ZM0 456V0h132l170 242V0h135.5v456H302L132 214v242H0Z" />
							</g>
						</svg>
					</div>

					<ReactMarkdown className="popup--marketing__tagline">
						{t("MARKETING.NEXT_POPUP.TAGLINE")}
					</ReactMarkdown>
				</div>

				<div className="popup__footer popup--marketing__footer">
					<img
						src="/assets/images/logo-negative.svg"
						alt=""
						className="popup--marketing__logo"
					/>
				</div>
			</div>
		</div>
	);
});
